/*
 * @Author: louzhedong
 * @Date: 2020-09-14 10:24:28
 * @LastEditors: louzhedong
 * @LastEditTime: 2020-09-19 16:10:55
 * @Description: 
 */
import $ from 'jquery';
import CONFIG from './config'
import { message } from './function'
// import User from './user'
const conf: any = CONFIG;

function request(method: string, url: string, params: any, option: any) {
  return new Promise(function (resolve, reject) {

    url = conf.api + url;

    const ajaxOptions = {
      data: params,
      type: method || 'POST',
      url,
      contentType: option.contentType || 'application/x-www-form-urlencoded; charset=UTF-8',
      timeout: 20000,
  
    
      dataType: option.dataType || 'json',
      processData: option.processData || true,
      beforeSend(xhr: any) {
        option.beforeSend && option.beforeSend(xhr);
      },
      success(res: any) {
        // debugger
        if (res.success) {
          resolve(res);
        } else if (res.code == 'LOGIN_OVERDUE') {
          reject(res)
        } else {
          processRequestError(res);
          reject(res)
        }
      },
      error(xhr: any) {
        if (xhr.status == 401) {
          if (location.href.indexOf('login') !== -1) {
            reject(xhr);
          }
          // User.loginIn();
        } else {
          processHttpError(xhr);
          reject(xhr);
        }

      }
    }

    $.ajax(ajaxOptions);

  });

}

function processRequestError(res: any) {
  message(res.message || res.resultMsg);
}

function processHttpError(xhr: any) {
  if (xhr.status == 400) {
    message('请正确填写数据！错误码（400）');
  } else if (xhr.status == 500) {
    message('服务端发生错误！错误码（500）');
  } else if (xhr.status == 404) {
    message('服务端未处理该请求！错误码（404）');
  } else {
    message('服务端开小差了，请稍后再试~');
  }
}

class Axios {
  static post(url: string, params = {}, option = {}) {
    return request('post', url, params, option);
  }
  static postJSON(url: string, params: any = {}, option: any = {}) {
    option = option || {};
    option.contentType = 'application/json; charset=UTF-8';
    return request('post', url, JSON.stringify(params), option);
  }
}


export default Axios;